import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Box, IconButton, InputBase, Typography } from '@mui/material';
import { COLUMN, COMPOSER_SHELL } from './styles';
export function LivyComposer(_ref) {
  let onSend = _ref.onSend,
    onStop = _ref.onStop,
    streaming = _ref.streaming,
    placeholder = _ref.placeholder,
    disclaimer = _ref.disclaimer;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  const ready = value.trim().length > 0 && !streaming;
  const submit = () => {
    if (!ready) return;
    onSend(value);
    setValue('');
  };
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      px: {
        xs: '16px',
        sm: '24px'
      },
      pb: '16px',
      pt: '4px'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: COLUMN
  }, /*#__PURE__*/React.createElement(Box, {
    sx: COMPOSER_SHELL
  }, /*#__PURE__*/React.createElement(InputBase, {
    multiline: true,
    maxRows: 8,
    value: value,
    onChange: e => setValue(e.target.value),
    placeholder: placeholder,
    inputProps: {
      'aria-label': 'Message Livy'
    },
    sx: {
      flex: 1,
      fontSize: 14.5,
      lineHeight: 1.5,
      py: '5px'
    },
    onKeyDown: e => {
      // Enter sends; Shift-Enter is a newline, which is what people expect of a chat box.
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        submit();
      }
    }
  }), /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    "aria-label": streaming ? 'Stop' : 'Send',
    onClick: streaming ? onStop : submit,
    disabled: !streaming && !ready,
    sx: {
      width: 32,
      height: 32,
      borderRadius: '10px',
      flex: '0 0 auto',
      color: streaming ? 'text.primary' : 'primary.contrastText',
      bgcolor: streaming ? 'action.selected' : 'primary.main',
      '&:hover': {
        bgcolor: streaming ? 'action.selected' : 'primary.dark'
      },
      '&.Mui-disabled': {
        bgcolor: 'action.disabledBackground',
        color: 'text.disabled'
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    component: "span",
    sx: {
      fontSize: 15,
      lineHeight: 1
    }
  }, streaming ? '■' : '↑'))), disclaimer && /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "text.secondary",
    sx: {
      display: 'block',
      textAlign: 'center',
      mt: '8px',
      fontSize: 11,
      opacity: 0.8
    }
  }, disclaimer)));
}